export const updateMessages = {
  updateAvailableTitle: 'Linketry {version} is available',
  updateAvailableDescription:
    'You are running {currentVersion}. Review the changes, then approve deployment in GitHub Actions.',
  updateAvailableAutomaticDescription:
    'You are running {currentVersion}. Review the changes, then deploy the update here.',
  viewChanges: 'View changes',
  viewDeployment: 'View deployment',
  viewUpdateDetails: 'View update',
  viewUpgradeProgress: 'View progress',
  upgradeOnline: 'Upgrade online',
  openDeployment: 'Open deployment',
  checkForUpdates: 'Check for updates',
  checkingForUpdates: 'Checking for updates',
  sidebarUpdateAvailable: 'v{version} available',
  sidebarUpgradeInProgress: 'Upgrade in progress',
  sidebarUpgradeFailed: 'Upgrade needs attention',
  updateCheckCurrent: 'Linketry {version} is up to date.',
  updateCheckFailed: 'Could not check GitHub for updates.',
  releaseStatus: 'Release Status',
  releaseStatusDescription: 'Installed release, GitHub version, and deployment readiness.',
  versionCenterTitle: 'Version Center',
  versionCenterDescription:
    'Review the installed release, check deployment readiness, and follow the protected upgrade from one place.',
  installedVersion: 'Installed version',
  latestGitHubVersion: 'Latest GitHub version',
  lastUpdateCheck: 'Last checked',
  upgradeMethod: 'Upgrade method',
  upToDate: 'Up to date',
  updateAvailable: 'Update available',
  updateStatusUnavailable: 'Check unavailable',
  oneClickUpgradeReady: 'One-click upgrade ready',
  manualDeploymentRequired: 'Manual deployment',
  upgradeConfigurationInvalid: 'Invalid upgrade configuration',
  upgradeCapabilityUnavailable: 'Upgrade status unavailable',
  oneClickUpgradeReadyDescription:
    'This instance can deploy its own configured repository and branch to its protected production environment.',
  oneClickUpgradeSecretRequired:
    'Automatic upgrade is disabled. Add the LINKETRY_GITHUB_UPDATE_TOKEN repository secret to enable it; the protected GitHub Actions workflow remains available.',
  oneClickUpgradeInvalidDescription:
    'The configured update repository or branch is invalid. Review the deployment variables before upgrading.',
  oneClickUpgradeUnavailableDescription:
    'The Worker upgrade capability could not be checked. The protected GitHub Actions workflow remains available.',
  upgradingOnline: 'Upgrading',
  checkingUpgrade: 'Checking upgrade',
  confirmUpgradeTitle: 'Confirm online upgrade',
  confirmUpgradeMessage:
    "Deploy Linketry {version} from this instance's configured repository and branch? The protected backup, migration, target, and release gates must all pass.",
  confirmUpgrade: 'Confirm upgrade',
  upgradeStarting: 'Starting the protected deployment...',
  upgradeQueued: 'Deployment is queued in GitHub Actions...',
  upgradeRunning: 'Worker and Admin deployment is running...',
  upgradeFinalizing: 'New release detected. Waiting for Worker and Admin assets...',
  upgradeSucceeded: 'Upgrade complete. Reloading the Admin...',
  upgradeProgressTitle: 'Protected deployment progress',
  upgradeCompleteTitle: 'Deployment verified',
  upgradeFailureTitle: 'Upgrade needs attention',
  retryUpgrade: 'Retry upgrade',
  upgradeStepPrepare: 'Start protected deployment',
  upgradeStepQueue: 'Wait for GitHub Actions',
  upgradeStepDeploy: 'Deploy Worker and Admin',
  upgradeStepVerify: 'Verify runtime and Admin assets',
  upgradeFailed: 'Deployment ended with status: {conclusion}.',
  upgradeFailedGeneric: 'Online upgrade failed.',
  upgradeTimeout: 'Deployment did not finish in time.',
  upgradeVerificationFailed:
    'Deployment succeeded, but this page could not verify the running version. Reload to confirm the update.',
  upgradePropagationTitle: 'Deployment complete. Waiting for Linketry {version}',
  upgradePropagationRefreshing:
    'This page is still running {currentVersion}. It will refresh once more in a few seconds.',
  upgradePropagationManual:
    'This page is still running {currentVersion}. Refresh the page to load the deployed version.',
  refreshNow: 'Refresh now',
  dismissUpgradeResult: 'Dismiss upgrade result',
  dismissUpdate: 'Dismiss update notice',
  closeVersionPanel: 'Close version status',
} as const;
